<script>
  export let text1 = "Section";
  export let text2 = "Title";
  export let colorClass = "text-brand-green";
  export let breakWord = true;
</script>

<div
  class={`h-font text-center pt-20 pb-16 text-5xl lg:text-6xl justify-center flex ${breakWord && "flex-col sm:flex-row"}`}
>
  <h1 class="mr-3">{text1}</h1>
  <h1 class={colorClass}>{text2}</h1>
</div>
